import { useStoreMap, useUnit } from 'effector-react';
import { $menuState } from '@nx-frontend/shared/store/feature-menu-tree';
import { $pageInfo } from '@nx-frontend/shared/store/portal-page';
import { ChangeEvent, ChangeEventWithPartialMeta, MenuItem, MenusState, MenuType } from '@nx-frontend/shared/types';

export const useGetPreparedChangeEvent = (): ((event: ChangeEventWithPartialMeta) => ChangeEvent) => {
  const [{ title, path, pageId }] = useUnit([$pageInfo]);
  const menuItemResult: MenuItem | null = useStoreMap({
    keys: [path],
    defaultValue: null,
    store: $menuState,
    fn: (state: MenusState, [path]: [string]) => {
      const items = [MenuType.PORTAL_TOPBAR, MenuType.PORTAL_SIDEBAR, MenuType.PORTAL_FOOTER].flatMap((menuType) =>
        Object.values(state[menuType].entities)
      );
      return items.find((obj) => {
        return obj.url === path;
      });
    },
    updateFilter: (next: MenuItem | null, prev: MenuItem | null) => {
      return next?.url !== prev?.url || next?.originalUrl !== prev?.originalUrl;
    },
  });

  return (event: ChangeEventWithPartialMeta) => {
    const meta = {
      userId: 0,
      path: menuItemResult?.originalUrl ?? path,
      pageId,
      updatedAt: Date.now(),
      pageTitle: title ? title : path === '/' ? 'Home Page' : String(path.split('/').pop()).replaceAll('-', ' '),
      ...event.meta,
    };
    return {
      ...event,
      meta,
    };
  };
};
